type UnwrappableResult<T> = {
  unwrap: () => Promise<T>;
};

const isUnwrappableResult = <T>(value: unknown): value is UnwrappableResult<T> =>
  typeof value === 'object' &&
  value !== null &&
  'unwrap' in value &&
  typeof value.unwrap === 'function';

export const unwrapDispatchResult = <T>(value: unknown): Promise<T> => {
  if (!isUnwrappableResult<T>(value)) {
    return Promise.reject(new Error('Dispatched action does not support unwrap'));
  }

  return value.unwrap();
};
